import cn from 'classnames';

import { IConDefaultType } from '../types';

interface IVoteIconProps extends IConDefaultType {}

function VoteIcon({ className, size = 24, rotate, flip, color = '#303037' }: IVoteIconProps) {
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.0065 1.89335C14.8153 0.702215 12.8841 0.702219 11.693 1.89335L7.96013 5.62622C6.769 6.81735 6.76899 8.74856 7.96013 9.93969L10.168 12.1475C11.3591 13.3386 13.2903 13.3386 14.4814 12.1475L18.2143 8.41465C19.4054 7.22352 19.4054 5.29231 18.2143 4.10118L16.0065 1.89335ZM13.1308 3.33117C13.5279 2.93413 14.1716 2.93413 14.5686 3.33117L16.7765 5.539C17.1735 5.93604 17.1735 6.57978 16.7765 6.97682L13.0436 10.7097C12.6466 11.1067 12.0028 11.1067 11.6058 10.7097L9.39795 8.50187C9.00091 8.10482 9.00091 7.46109 9.39795 7.06404L13.1308 3.33117ZM6.82202 14.7193C7.18744 14.2929 7.13807 13.6511 6.71174 13.2857C6.28541 12.9203 5.64357 12.9696 5.27815 13.396L3 16.0538V19.1411C3 20.8256 4.36557 22.1912 6.05008 22.1912H18.2504C19.9349 22.1912 21.3005 20.8256 21.3005 19.1411V16.0538L19.0224 13.396C18.6569 12.9696 18.0151 12.9203 17.5888 13.2857C17.1624 13.6511 17.1131 14.2929 17.4785 14.7193L18.0733 15.4132H6.22721L6.82202 14.7193ZM5.03339 17.4466H19.2671V19.1411C19.2671 19.7026 18.8119 20.1578 18.2504 20.1578H6.05008C5.48858 20.1578 5.03339 19.7026 5.03339 19.1411V17.4466Z"
          fill={color}
        />
      </svg>
    </i>
  );
}

export default VoteIcon;
